import { useRef, useEffect, useCallback } from 'react';
import { S as SCROLL_BUFFER } from './consts-fa6ab3c0.js';
function useDebounce(callback, delay) {
  var timeoutRef = useRef(null);
  useEffect(function () {
    // Cleanup the timeout on unmount
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  function debounceFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(function () {
      callback.apply(void 0, args);
    }, delay);
  }
  return debounceFunction;
}
var DELAY = 500;
function calcScrollBottom(scrollHeight, scrollTop) {
  return scrollHeight - scrollTop;
}
function useHandleOnScrollCallback(_ref) {
  var hasMore = _ref.hasMore,
    hasNext = _ref.hasNext,
    onScroll = _ref.onScroll,
    scrollRef = _ref.scrollRef,
    setShowScrollDownButton = _ref.setShowScrollDownButton;
  var scrollCb = useCallback(function () {
    var element = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (element == null) {
      return;
    }
    var scrollTop = element.scrollTop,
      scrollHeight = element.scrollHeight,
      clientHeight = element.clientHeight; // https://sendbird.atlassian.net/browse/SBISSUE-11759
    // the edge case where channel is inside a page that already has scroll
    // scrollintoView will move the whole page, which we dont want
    var scrollBottom = calcScrollBottom(scrollHeight, scrollTop);
    // even if there is more to fetch or not,
    // we still have to show the scroll to bottom button
    if (typeof setShowScrollDownButton === 'function') {
      setShowScrollDownButton(scrollHeight > scrollTop + clientHeight + 1);
    }
    if (hasMore && scrollTop < SCROLL_BUFFER) {
      onScroll(function () {
        // sets the scroll position to the bottom of the new messages
        element.scrollTop = element.scrollHeight - scrollBottom;
      });
    }
    if (hasNext) {
      onScroll(function () {
        // sets the scroll position to the top of the new messages
        element.scrollTop = scrollTop - (scrollHeight - element.scrollHeight);
      });
    }
  }, [setShowScrollDownButton, hasMore, onScroll, scrollRef]);
  return useDebounce(scrollCb, DELAY);
}
export { useHandleOnScrollCallback as a, useDebounce as u };